import {
  GET_EMERGENCY,
  GET_EMERGENCY_FULFILLED,
  GET_EMERGENCY_REJECTED,
  GET_EMERGENCY_PENDING
} from "../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EMERGENCY_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_EMERGENCY_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_EMERGENCY_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GET_EMERGENCY:
      return {
        ...state,
        data: [],
      };
    default:
      return state;
  }
}
